export default "skymp5-front/2400719913d1d7031317e8796e71c560.jpg";